import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const SpaceRolesPageRouteComponent = LoadableAfterPaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-SpaceRolesPageRouteComponent" */ './SpaceRolesPageRouteComponent.tsx'
		),
});

export const SpaceRolesPageRoute = () => <SpaceRolesPageRouteComponent />;

SpaceRolesPageRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: {
			name: 'spaceRolesScreen',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
